function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#A0AFBE",
  fillRule: "nonzero",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  fillRule: "nonzero",
  x: 7,
  y: 2,
  width: 2,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8 13V6H6"
}));
function SvgInfoGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}
export default SvgInfoGray;